export const GESTOCK_PLANS = {
  FREE: {
    key: "FREE",
    name: "Gratuit",
    price: 0,
    pricing: {
      monthly: {
        price: 0,
        durationMonths: 0,
        intervalLabel: "mois",
      },
      yearly: {
        price: 0,
        durationMonths: 0,
        intervalLabel: "an",
      },
    },
    limits: {
      maxProducts: 20,
      sms: {
        canSend: false,
        monthlyIncluded: 0,
        overagePrice: 15,
      },
    },
    features: {
      MOBILE_MONEY: false,
      ECOMMERCE: false,
      MULTI_STORE: false,
      ADVANCED_REPORTS: false,
    },
  },

  LITE: {
    key: "LITE",
    name: "Lite",
    price: 4900,
    pricing: {
      monthly: {
        price: 4900,
        durationMonths: 1,
        intervalLabel: "mois",
      },
      yearly: {
        price: 4900 * 12,
        durationMonths: 12,
        intervalLabel: "an",
      },
    },
    limits: {
      maxProducts: 75,
      sms: {
        canSend: true,
        monthlyIncluded: 20,
        overagePrice: 14,
      },
    },
    features: {
      MOBILE_MONEY: false,
      ECOMMERCE: false,
      MULTI_STORE: false,
      ADVANCED_REPORTS: false,
    },
  },

  STANDARD: {
    key: "STANDARD",
    name: "Standard",
    price: 9900,
    pricing: {
      monthly: {
        price: 9900,
        durationMonths: 1,
        intervalLabel: "mois",
      },
      yearly: {
        price: 9900 * 12,
        durationMonths: 12,
        intervalLabel: "an",
      },
    },
    limits: {
      maxProducts: 150,
      sms: {
        canSend: true,
        monthlyIncluded: 50,
        overagePrice: 13,
      },
    },
    features: {
      MOBILE_MONEY: false,
      ECOMMERCE: false,
      MULTI_STORE: false,
      ADVANCED_REPORTS: false,
    },
  },

  PRO: {
    key: "PRO",
    name: "Pro",
    price: 15900,
    pricing: {
      monthly: {
        price: 15900,
        durationMonths: 1,
        intervalLabel: "mois",
      },
      yearly: {
        price: 15900 * 12,
        durationMonths: 12,
        intervalLabel: "an",
      },
    },
    limits: {
      maxProducts: 200,
      sms: {
        canSend: true,
        monthlyIncluded: 100,
        overagePrice: 12,
      },
    },
    features: {
      MOBILE_MONEY: false,
      ECOMMERCE: false,
      MULTI_STORE: false,
      ADVANCED_REPORTS: true,
    },
  },

  BUSINESS: {
    key: "BUSINESS",
    name: "Business",
    price: 25900,
    pricing: {
      monthly: {
        price: 25900,
        durationMonths: 1,
        intervalLabel: "mois",
      },
      yearly: {
        price: 25900 * 12,
        durationMonths: 12,
        intervalLabel: "an",
      },
    },
    limits: {
      maxProducts: null,
      sms: {
        canSend: true,
        monthlyIncluded: 300,
        overagePrice: 10,
      },
    },
    features: {
      MOBILE_MONEY: false,
      ECOMMERCE: true,
      MULTI_STORE: true,
      ADVANCED_REPORTS: true,
    },
  },
}

export const SMS_PARTNER_COST_FCFA = 8
